import {
    ROUTES_FETCHING,
    ROUTES_FAILED,
    ROUTES_SUCCESS,
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case ROUTES_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };    
        case ROUTES_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case ROUTES_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false};
        default:
            return state;
    }
}